import { render, staticRenderFns } from "./noDevice.vue?vue&type=template&id=66ed5e11&scoped=true"
import script from "./noDevice.vue?vue&type=script&lang=js"
export * from "./noDevice.vue?vue&type=script&lang=js"
import style0 from "./noDevice.vue?vue&type=style&index=0&id=66ed5e11&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66ed5e11",
  null
  
)

export default component.exports